/* eslint-disable @typescript-eslint/naming-convention */
import { useState } from 'react'
import { Button, Input, InputGroup, InputRightElement } from '@chakra-ui/react'

import { useGetPlayerById } from '@hooks/useGetPlayerByIDSearch'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

export function GetPlayerByIdField() {
    const [id, setId] = useState('')
    const { setNewPlayer } = useAddPlayerContext()

    const { getPlayerById, isLoading } = useGetPlayerById()

    const handlePlayerSelect = async () => {
        const player = await getPlayerById(id)

        if (!player) {
            setId('')

            return
        }

        setNewPlayer(player)
    }

    return (
        <InputGroup w="full" id="get-player-by-id">
            <Input
                className="search-value-input"
                placeholder="Player ID"
                value={id}
                onChange={e => setId(e.target.value)}
            />
            <InputRightElement width="4.5rem">
                <Button colorScheme="blue" h="1.75rem" size="sm" onClick={handlePlayerSelect} isLoading={isLoading}>
                    {isLoading ? 'Fetching...' : 'Fetch'}
                </Button>
            </InputRightElement>
        </InputGroup>
    )
}
